/** Preserve occupied places using the latest counters read by the transaction. */
export const capacityUpdate = (
  current: { maxParticipants: number; remainingPlaces: number },
  nextCapacity: number
): { maxParticipants: number; remainingPlaces?: number } => {
  if (!Number.isInteger(nextCapacity) || nextCapacity < 0) {
    throw new Error('Le nombre de places doit être un entier positif ou nul.');
  }
  if (nextCapacity === current.maxParticipants) return { maxParticipants: nextCapacity };

  if (!Number.isInteger(current.maxParticipants) || !Number.isInteger(current.remainingPlaces)) {
    throw new Error('Les compteurs de places de cet atelier sont invalides.');
  }
  const occupied = current.maxParticipants - current.remainingPlaces;
  if (occupied < 0 || nextCapacity < occupied) {
    throw new Error(`La capacité ne peut pas être inférieure aux ${Math.max(0, occupied)} places déjà réservées.`);
  }
  return { maxParticipants: nextCapacity, remainingPlaces: nextCapacity - occupied };
};
